import * as React from "react";
import { connect } from "react-redux";

import {
  Coupons as CouponsComponent,
  CouponsProps,
} from "../../components/Coupons/Coupons";
import { getCouponsAction } from "../../actions";
import { StoreState } from "../../reducers";
import { getCoupons } from "../../reducers/reward/methods";

interface CouponsContainerProps extends CouponsProps {
  getCouponsAction: typeof getCouponsAction;
  coupons: ReturnType<typeof getCoupons>;
}

class Coupons extends React.Component<CouponsContainerProps> {
  componentDidMount() {
    this.props.getCouponsAction();
  }

  render() {
    return <CouponsComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  coupons: getCoupons(state.reward),
});

export default connect(mapStateToProp, { getCouponsAction })(Coupons);
